import { formatLocalDate, isLocationEmpty, getTimeZoneFromLocation } from '@caresend/utils';
import dayjs from 'dayjs';
import { getStore } from '../../../helpers/initStore.js';

/**
 * Transforms lab appointment times to a format that can be used in the UI.
 */
const transformLabAppointmentTimes = (validAppointmentTimes, timeZone) => validAppointmentTimes.reduce((groupedTimes, timestamp) => {
    var _a;
    // Get the day timestamp at 12 AM in the lab time zone
    const dayTimestamp = dayjs(timestamp)
        .tz(timeZone)
        .startOf('day')
        .utc()
        .valueOf();
    // Format the time as string in the lab time zone
    const timeStringInLabTimeZone = formatLocalDate(timestamp, 'h:mm a', timeZone);
    const appointmentTimesForDay = (_a = groupedTimes[dayTimestamp]) !== null && _a !== void 0 ? _a : [];
    appointmentTimesForDay.push({
        id: timestamp.toString(),
        label: timeStringInLabTimeZone,
    });
    return {
        ...groupedTimes,
        [dayTimestamp]: appointmentTimesForDay,
    };
}, {});
/**
 * Gets the time zone for the lab from it's location. If the lab location's
 * time zone is not set, we source it from the lab location's lat/lng.
 */
const getLabTimeZone = async (selectedDrawPlaceID) => {
    const store = getStore();
    const labOption = store.state.schedulingFlow.labOptions[selectedDrawPlaceID];
    if (!labOption || isLocationEmpty(labOption.location))
        return;
    const { lat, lng, timeZone } = labOption.location;
    if (timeZone)
        return timeZone;
    const { timeZoneId } = await getTimeZoneFromLocation([lat, lng]);
    return timeZoneId;
};

export { getLabTimeZone, transformLabAppointmentTimes };
